import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=88c4e772"
import script from "./employeeDetail.vue?vue&type=script&lang=js"
export * from "./employeeDetail.vue?vue&type=script&lang=js"
import style0 from "./employeeDetail.vue?vue&type=style&index=0&id=88c4e772&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "employeeDetail.vue"
export default component.exports